import classNames from 'classnames';
import Footer from 'components/footers/Footer';
import NavbarTopDefault from 'components/navbars/navbar-top/NavbarTopDefault';
import NavbarTopHorizontal from 'components/navbars/navbar-horizontal/NavbarTopHorizontal';
import NavbarVerticalCSA from 'components/navbars/navbar-vertical/NavbarVerticalCSA';
import { useAppContext } from 'providers/AppProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import DomainCatalogBootstrap from 'components/bootstrap/DomainCatalogBootstrap';
import { SentryErrorBoundary } from 'components/errors/SentryErrorBoundary';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

const CSAPlusLayout = () => {
  const {
    config: { navbarPosition }
  } = useAppContext();

  const { contentClass, footerClass } = useMainLayoutContext();

  return (
    <Container fluid className="px-0">
      <DomainCatalogBootstrap />
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && <NavbarVerticalCSA />}
      {navbarPosition === 'vertical' && <NavbarTopDefault />}
      {(navbarPosition === 'horizontal' || navbarPosition === 'combo') && <NavbarTopHorizontal />}

      <div className={classNames(contentClass, 'content')}>
        <SentryErrorBoundary name="csa-plus-layout">
          <Outlet />
        </SentryErrorBoundary>
        <Footer className={classNames(footerClass, 'position-absolute')} />
      </div>
    </Container>
  );
};

export default CSAPlusLayout;
